// src/App.js
import React from 'react';
import Calculator from './components/FinalCalc';
import './App.css';

function App() {
  return (
    <div className="App">
      <Calculator />
    </div>
  );
}

export default App;
